module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "box",
    class: {
      filled: _vm.filled
    }
  }, [(_vm.icon) ? _c('div', {
    staticClass: "icon-container"
  }, [_c('icon', {
    attrs: {
      "name": _vm.icon,
      "scale": 2.4
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "content"
  }, [(!this.$slots["title"] && _vm.title) ? _c('h5', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._t("title"), (!this.$slots["description"] && _vm.description) ? _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._t("description"), (_vm.link) ? _c('b-btn', {
    attrs: {
      "variant": "link",
      "to": _vm.link.to
    }
  }, [_vm._v(_vm._s(_vm.link.text)), _c('icon', {
    staticClass: "ml-2",
    attrs: {
      "name": "arrow-right",
      "scale": 0.8
    }
  })], 1) : _vm._e()], 2), (this.$slots["right"]) ? _c('div', {
    staticClass: "right-slot"
  }, [_vm._t("right")], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b4e0311"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rabbit/campaign-notification/CampaignNotification.vue
// module id = 2068
// module chunks = 1